import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IPaymentVoucherSetupToolbar {
	// onSaveAsDraftButtonClickedHandler: () => void
	onSaveAndPostButtonClickedHandler: () => void
	onResetButtonClickedHandler: () => void
}

export const PaymentVoucherSetupToolbar: FC<IPaymentVoucherSetupToolbar> = ({
	// onSaveAsDraftButtonClickedHandler,
	onSaveAndPostButtonClickedHandler,
	onResetButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save as Draft"
					// onClickHandler={onSaveAsDraftButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					type="submit"
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Save & Post"
					onClickHandler={onSaveAndPostButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Reset"
					raised
					onClickHandler={onResetButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Toolbar>
		</AppBar>
	);
};
